export default __webpack_public_path__ + "static/media/azure.16afec27.svg";